import React from 'react';
import CtaButtons from '../components/CtaButtons.js';

const Home = (props) => {
   return(
      <div className="page" data-view="home">
         <div className="side-buttons">
            <CtaButtons />
         </div>
      </div>
   )
}

export default Home;